import { Flex, Icon, Text } from '@workwhile/ui'
import styled from 'styled-components'
import { CircleAlertIcon } from 'lucide-react'
import { config } from 'config'
import { useLatestAppVersion } from 'queries/app'
import { useGateValue } from '@statsig/react-bindings'
import { FeatureGates } from 'lib/statsig/feature_gates'

const UpdateBannerContainer = styled(Flex).attrs({
  alignItems: 'center',
  justifyContent: 'center',
  p: 3,
})`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000000;
`

export function UpdateBanner() {
  const shouldEnableUpdateNotification = useGateValue(
    FeatureGates.EnableUpdateNotification
  )
  const { data: latestVersion } = useLatestAppVersion({
    enabled: shouldEnableUpdateNotification,
  })
  const isLatestVersion = config.appVersion === latestVersion

  const handleUpdate = () => {
    window.location.reload()
  }

  if (!shouldEnableUpdateNotification || !latestVersion || isLatestVersion) {
    return null
  }

  return (
    <UpdateBannerContainer mr={[6, 0]}>
      <Flex
        onClick={handleUpdate}
        style={{ cursor: 'pointer', opacity: 0.9 }}
        bg="warning100"
        borderRadius={20}
        alignItems="center"
        gap={2}
        py={2}
        px={3}
      >
        <Icon icon={CircleAlertIcon} />
        <Text>
          A new version of the portal is available. Click here to reload.
        </Text>
      </Flex>
    </UpdateBannerContainer>
  )
}
